export const isMobile = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(max-width: 767px)').matches;
};

export const isTablet = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches;
};

export const isDesktop = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(min-width: 1024px)').matches;
};

/** Phones, tablets, and Android laptops cannot run pressure scan or WBCT. */
export const isScanHardwareUnsupportedDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua)) return true;
  if (/iPhone|iPod|iPad|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return true;
  if (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1) return true;
  return /Mobile/i.test(ua);
};

export const SCAN_HARDWARE_UNSUPPORTED_TOAST =
  'Pressure tests and WBCT are not available on this device. Use a computer.';
